export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 text-center mb-6">
          Czym jest Kakobuy Spreadsheet?
        </h2>
        <div className="flex justify-center mb-10">
          <div className="w-16 h-1 bg-accent-500 rounded-full"></div>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 mb-12 items-center">
          <div className="lg:w-1/2">
            <img
              src="https://readdy.ai/api/search-image?query=A%20modern%20laptop%20screen%20displaying%20a%20colorful%20organized%20spreadsheet%20with%20product%20rows%20and%20category%20columns%20on%20a%20warm%20oak%20desk%2C%20soft%20natural%20daylight%20from%20the%20side%2C%20a%20ceramic%20coffee%20cup%20and%20a%20small%20potted%20succulent%20nearby%2C%20warm%20cream%20walls%2C%20European%20home%20office%20aesthetic%2C%20clean%20organized%20workspace%2C%20gentle%20shadows%2C%20editorial%20workspace%20photography&width=600&height=420&seq=about-spreadsheet-2026&orientation=landscape"
              alt="Kakobuy Spreadsheet — uporządkowana lista produktów zakupowych"
              className="w-full rounded-xl object-cover aspect-[4/3]"
              title="Kakobuy Spreadsheet — zorganizowana lista produktów"
            />
          </div>
          <div className="lg:w-1/2">
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-4">
              Kakobuy Spreadsheet to uporządkowana lista najlepszych produktów,
              która pomaga użytkownikom szybciej znaleźć popularne produkty,
              sprawdzone linki oraz aktualne trendy zakupowe.
            </p>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
              Zamiast godzinami szukać produktów samodzielnie,
              możesz korzystać z gotowych kategorii przygotowanych
              dla użytkowników Kakobuy.
            </p>
          </div>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-800 whitespace-nowrap">Metoda</th>
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-800 whitespace-nowrap">Czas wyszukiwania</th>
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-800 whitespace-nowrap">Ryzyko</th>
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-800 whitespace-nowrap">Efektywność</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-background-200/60">
              <tr className="hover:bg-background-100/50 transition-colors">
                <td className="px-5 py-3.5 text-foreground-700 whitespace-nowrap">Samodzielne szukanie</td>
                <td className="px-5 py-3.5 text-foreground-600 whitespace-nowrap">3-5 godzin</td>
                <td className="px-5 py-3.5">
                  <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-800 whitespace-nowrap">
                    Wysokie
                  </span>
                </td>
                <td className="px-5 py-3.5 text-accent-600 whitespace-nowrap">★★</td>
              </tr>
              <tr className="hover:bg-background-100/50 transition-colors">
                <td className="px-5 py-3.5 text-foreground-700 whitespace-nowrap">Social media</td>
                <td className="px-5 py-3.5 text-foreground-600 whitespace-nowrap">1-3 godziny</td>
                <td className="px-5 py-3.5">
                  <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-800 whitespace-nowrap">
                    Średnie
                  </span>
                </td>
                <td className="px-5 py-3.5 text-accent-600 whitespace-nowrap">★★★</td>
              </tr>
              <tr className="hover:bg-background-100/50 transition-colors">
                <td className="px-5 py-3.5 text-foreground-700 font-semibold whitespace-nowrap">Kakobuy Spreadsheet</td>
                <td className="px-5 py-3.5 text-foreground-600 whitespace-nowrap">Kilka minut</td>
                <td className="px-5 py-3.5">
                  <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-800 whitespace-nowrap">
                    Niskie
                  </span>
                </td>
                <td className="px-5 py-3.5 text-accent-600 font-semibold whitespace-nowrap">★★★★★</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}